import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { LevelService } from '../proxy/controlling/controllers/level.service';
import { ActivityService } from '../proxy/controlling/controllers/activity.service';

FieldBuilder.setNamespace('Controlling');

export const LEVELPERACTIVITY_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .foreignKey('levelId', 'Entity.Level', LevelService)
    .required()
    .displayFromNested('level.name')
    .sortBy('level.name')
    .build(),
  FieldBuilder
    .foreignKey('activityId', 'Entity.Activity', ActivityService)
    .required()
    .displayFromNested('activity.name')
    .sortBy('activity.name')
    .hideInChildForms()
    .build(),
];

export const LEVELPERACTIVITY_CONFIG = {
  entityName: 'LevelPerActivity',
  localizationKey: 'Controlling::Entity.LevelPerActivity',
  fields: LEVELPERACTIVITY_FIELDS,
  permission: 'ControllingActivities.LevelPerActivities',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Activities + MENU_NAME_SUFFIX,
};
